import { Box, Grid, Typography, useMediaQuery } from "@mui/material";
import { Labeled, useRecordContext } from "react-admin";

import { settings } from "app";
import permissions from "app/permissions";
import { erasmusRequests } from "api/erasmusApi";
import { SectionTitle } from "features/SectionTitle";
import SecuredComponent from "server/security/SecuredComponent";
import DocumentFileLink from "../../Partials/DocumentFileLink";
import UploadDocumentDialog from "./components/UploadDocumentDialog";

// uploadUrl is optional - the CV has no endpoint of its own, so it is preview only.
const DocumentItem = ({ label, documentId, uploadUrl }) => (
  <Grid
    item
    xs={12}
    md={4}
  >
    <Labeled label={label}>
      {documentId ? (
        <DocumentFileLink
          id={documentId}
          documentName={label}
        />
      ) : (
        <Typography>-</Typography>
      )}
    </Labeled>
    {uploadUrl ? (
      <SecuredComponent permission={permissions.canManageErasmusInternshipStudents}>
        <Box mt={1}>
          <UploadDocumentDialog
            url={uploadUrl}
            label={label}
            hasFile={Boolean(documentId)}
          />
        </Box>
      </SecuredComponent>
    ) : null}
  </Grid>
);

const DocumentsSection = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));
  const record = useRecordContext();

  const userInfo = record?.userInfo;

  if (!userInfo) return null;

  return (
    <>
      <SectionTitle
        paddingY={2}
        title="Документи"
        textAlign="center"
      />
      <Grid
        container
        spacing={2}
        sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
      >
        <DocumentItem
          label="CV"
          documentId={userInfo.cvDocumentId}
        />
        <DocumentItem
          label="Мотивационно писмо"
          documentId={userInfo.motivationLetterDocumentId}
          uploadUrl={erasmusRequests.updateIncomingInternshipStudentMotivationLetter(record.id)}
        />
        <DocumentItem
          label="Споразумение за обучение"
          documentId={userInfo.learningAgreementDocumentId}
          uploadUrl={erasmusRequests.updateIncomingInternshipStudentLearningAgreement(record.id)}
        />
      </Grid>
    </>
  );
};

export default DocumentsSection;
